var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showrrprice
      ? _c("div", [
          _c("label", [_vm._v("RRP:")]),
          _vm._v(" "),
          _c("span", { staticClass: "retail-price" }, [
            _vm._v(
              "\n      " + _vm._s(_vm._f("currency")(_vm.rrpprice)) + "\n    "
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("label", [_vm._v("Price:")]),
      _vm._v(" "),
      _c("span", { staticClass: "sale-price" }, [
        _vm._v(
          "\n      " + _vm._s(_vm._f("currency")(_vm.sellPrice)) + "\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }